import Vue from 'vue'
import Router from 'vue-router'
// import layout from '../pages/container/TheContainer.vue'
import layout from '../pages/container/dashboard2/TheContainer.vue'
import interviewerLayout from '../pages/container/interviewerLayout/TheContainer.vue'
import packagelayout from '../pages/container/package/TheContainer.vue'
// import layout1 from '../pages/container/dashboard2/TheContainer1.vue'
// import Dashboard from '../pages/Feature/Dashboard.vue'
import Dashboard from '../pages/Feature/Dashboard1.vue'
import Empty from '../pages/Feature/empty.vue'
import Login from '../pages/Feature/Login.vue'
import Registration from '../pages/Feature/Registration.vue'
import ForgetPassword from '../pages/Feature/forgetPassword'
import SetPassword from '../pages/Feature/setPassword'
import OrganizationProfile from '../pages/Feature/organization_profile.vue'
import Post from '../pages/Feature/post.vue'
import ToBeShedule from '../pages/Feature/to-be-shedule.vue'
import Shedule from '../pages/Feature/shedule.vue'
import Result from '../pages/Feature/result.vue'
import Registrationcomplete from '../pages/Feature/registerationComplete.vue'
import ForgetPasswordcomplete from '../pages/Feature/forgetpasswordComplete.vue'
import agoraHome from '../pages/agora/pages/Home.vue'
import agoraMeeting from '../pages/agora/pages/Meeting.vue'
import meetingstart from '../pages/agora/pages/start_pending.vue'
import meetingend from '../pages/agora/pages/meeting_end.vue'
import profile from '../pages/Feature/profile.vue'
import setpasswordmobile from '../pages/Feature/setPasswordMobile.vue'
import settings from '../pages/Feature/settings.vue'
import addfeedback from '../pages/Feature/addFeedback.vue'
import viewfeedback from '../pages/Feature/viewFeedback.vue'
import addfeedbackCommon from '../pages/Feature/addFeedback_common.vue'
import viewfeedbackCommon from '../pages/Feature/viewFeedback_common.vue'
import Faq from '../pages/Feature/faq.vue'
import Report from '../pages/Feature/report.vue'
import ShedulelistReport from '../pages/Feature/shedulelistReport.vue'
import resultpdf from '../pages/Feature/result_pdf.vue'
import feedbackCommonPdf from '../pages/Feature/feedback_common_pdf.vue'
import feedbackEnd from '../pages/Feature/feedback_end.vue'
import viewInterviewVideo from '../pages/Feature/viewInterviewVideo.vue'
import codeEditor from '../pages/Feature/codeEditor.vue'
import viewCode from '../pages/Feature/viewCode.vue'
import meetingConfirmation from '../pages/Feature/meeting_confirmation.vue'
import acsInterviewReport from '../pages/Feature/acs_interviewer_report.vue'
import acsScreeningMetricsReport from '../pages/Feature/acs_screening_metrics_report.vue'
import acsConsolidatedRoleReport from '../pages/Feature/acs_consolidated_role_report.vue'
import acsConsolidatedTaReport from '../pages/Feature/acs_consolidated_ta_report.vue'
// import ScheduleAvailability from '../pages/Feature/scheduleAvailability.vue'
// import MyAvailability from '../pages/Feature/myAvailability.vue'
import acsPaymentSummaryReport from '../pages/Feature/acs_payment_summary_report.vue'
import CandidateInterviewDetails from '../pages/Feature/candidate_interview_details.vue'
import acsInterviewConductedReport from '../pages/Feature/acs_interview_conducted_report.vue'
import viewfeedbackfWord from '../pages/Feature/viewFeedback-word.vue'
// interviewer login
import ScheduleAvailability from '../pages/Feature/scheduleAvailability.vue'
import MyAvailability from '../pages/Feature/myAvailability.vue'
import LoginPage from '../pages/Feature/LoginPage.vue'
import RegistrationPage from '../pages/Feature/RegistrationPage.vue'
import forgotPasswordPage from '../pages/Feature/forgotPasswordPage.vue'
import InterviewerBasicProfile from '../pages/Feature/InterviewerPage/Interviewer_BasicProfile.vue'
import InterviewerExperience from '../pages/Feature/InterviewerPage/InterviewerExperience.vue'
import InterviewerSkills from '../pages/Feature/InterviewerPage/InterviewerSkills.vue'
import UploadPage from '../pages/Feature/InterviewerPage/UploadPage.vue'
import InterviewerProfile from '../pages/Feature/InterviewerPage/InterviewerProfile.vue'
import myVideoCall from '../pages/agora/pages/myVideoCall.vue'
import ScheduleReportACS from '../pages/Feature/shedulelistReportACS.vue'
import postPage from '../pages/Feature/InterviewerPage/postPage.vue'
import InterestPage from '../pages/Feature/InterviewerPage/InterestPage.vue'
import schedulePage from '../pages/Feature/InterviewerPage/schedulePage.vue'
import feedbackPage from '../pages/Feature/InterviewerPage/feedbackPage.vue'
// package
import Selectpackage from '../pages/Feature/selectpackage.vue'
import packageMessage from '../pages/Feature/organizationPackageMessage.vue'
import packageMessage1 from '../pages/Feature/organizationPackageMessage1.vue'
import getauth from '../pages/Feature/getauth.vue'
import agoraModMeeting from '../pages/agoraMod/pages/Meeting.vue'
import acceptPending from '../pages/agora/pages/meeting_accept.vue'
// agoara
import videoCall from '../pages/agora/components/videoCall.vue'
// new org layout
import DashboardNew from '../newLayoutOrg/DashboardNew.vue'
import layoutNew from '../newLayoutOrg/dashboardHeader/TheContainerNew.vue'
import CandidateDetails from '../newLayoutOrg/CandidateDetails.vue'
import SetAvailability from '../newLayoutOrg/setAvailability.vue'
import selectInterviewer from '../newLayoutOrg/selectInterviewer.vue'
import newFeedback from '../newLayoutOrg/newFeedback.vue'
import ConfirmationNew from '../newLayoutOrg/ConfirmationNew.vue'
// screenitV3
import agoraHomeV3 from '../pages/agoraMod-v3/pages/Home.vue'
import agoraModMeetingV3 from '../pages/agoraMod-v3/pages/Meeting.vue'
import meetingstartV3 from '../pages/agoraMod-v3/pages/start_pending.vue'
import meetingendV3 from '../pages/agoraMod-v3/pages/meeting_end.vue'
import acceptPendingV3 from '../pages/agoraMod-v3/pages/meeting_accept.vue'
import addfeedbackCommonV3 from '../OrgLayoutV3/addFeedback_common_v3.vue'
import viewfeedbackCommonV3 from '../OrgLayoutV3/viewFeedback_common_v3.vue'
import codeEditorV3 from '../OrgLayoutV3/codeEditor_v3.vue'
import viewCodeV3 from '../OrgLayoutV3/viewCode_v3.vue'
import ScheduleConfirmation from '../OrgLayoutV3/schedule_confirmation_v3.vue'
import layoutV3 from '../OrgLayoutV3/dashboardHeader/TheContainerNew.vue'
import DashboardV3 from '../OrgLayoutV3/Dashboard_v3.vue'
import RegistrationV3 from '../OrgLayoutV3/Registration_v3.vue'
import ForgetPasswordV3 from '../OrgLayoutV3/forgetPassword_v3.vue'
import LoginV3 from '../OrgLayoutV3/Login_v3.vue'
import OrganizationProfileV3 from '../OrgLayoutV3/organization_profile_v3.vue'
import RegistrationcompleteV3 from '../OrgLayoutV3/registerationComplete_v3.vue'
import SetPasswordV3 from '../OrgLayoutV3/setPassword_v3.vue'
import CandidateDetailsV3 from '../OrgLayoutV3/CandidateDetails_v3.vue'
import selectInterviewerV3 from '../OrgLayoutV3/selectInterviewer_v3.vue'
import RequestShortlistV3 from '../OrgLayoutV3/request_shortlist_v3.vue'
import SetAvailabilityV3 from '../OrgLayoutV3/setAvailability_v3.vue'
import ProfileV3 from '../OrgLayoutV3/profile_v3.vue'
import IaaSRedirectionV3 from '../OrgLayoutV3/IaasRedirectionPage_v3.vue'
import CaaSRedirectionV3 from '../OrgLayoutV3/CaasRedirectionPage_v3.vue'
import ReportV3 from '../OrgLayoutV3/report_v3.vue'
import ShedulelistReportV3 from '../OrgLayoutV3/shedulelistReport_v3.vue'
import settingsV3 from '../OrgLayoutV3/settings_v3.vue'
import viewInterviewVideoV3 from '../OrgLayoutV3/viewInterviewVideo_v3.vue'
import AdminReportV3 from '../OrgLayoutV3/adminReport_v3.vue'
import OrgDetailsV3 from '../OrgLayoutV3/orgDetails_v3.vue'
import AdminDashboard from '../OrgLayoutV3/admin_dashboard.vue'
import AdminSettingsV3 from '../OrgLayoutV3/admin_settings_v3.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  hashbang: false,
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/Login_v3',
      name: 'Home',
      component: layout,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            title: 'screenit - dashboard'
          }
        }
      ]
    },
    {
      path: '/',
      name: 'Interviewer',
      component: interviewerLayout,
      children: [
        {
          path: '/scheduleAvailability/:id',
          name: 'ScheduleAvailability',
          component: ScheduleAvailability
        },
        {
          path: '/myAvailability/:id',
          name: 'myAvailability',
          component: MyAvailability
        },
        {
          path: '/InterviewerProfile/:id',
          name: 'InterviewerProfile',
          component: InterviewerProfile,
          meta: {
            title: 'InterviewerProfile'
          }
        },
        {
          path: '/JobPost/:id',
          name: 'JobPost',
          component: postPage
        },
        {
          path: '/Schedule/:id',
          name: 'Schedule',
          component: schedulePage
        },
        {
          path: '/Interest/:id',
          name: 'Interest',
          component: InterestPage
        },
        {
          path: '/Feedback/:id',
          name: 'Feedback',
          component: feedbackPage
        }
      ]
    },
    {
      path: '/',
      component: layout,
      children: [
        {
          path: 'report',
          name: 'Report',
          component: Report
        },
        {
          path: 'schedulereportacs',
          name: 'ScheduleReportACS',
          component: ScheduleReportACS
        },
        {
          path: 'SheduleReport',
          name: 'SheduleReport',
          component: ShedulelistReport,
          meta: {
            title: 'screenit - dashboard'
          }
        },
        {
          path: 'post',
          name: 'Post',
          component: Post,
          meta: {
            title: 'screenit - Post'
          }
        },
        {
          path: 'To-be-Scheduled',
          name: 'To-be-Scheduled',
          component: ToBeShedule
        },
        {
          path: 'scheduled',
          name: 'Scheduled',
          component: Shedule
        },
        {
          path: 'result',
          name: 'Result',
          component: Result
        },
        {
          path: '/settings',
          name: 'Settings',
          component: settings
        },
        {
          path: 'help',
          name: 'Help',
          component: Empty
        },
        {
          path: '/profile',
          name: 'Profile',
          component: profile
        },
        {
          path: '/acsreport',
          name: 'Interviewer Report',
          component: acsInterviewReport
        },
        {
          path: '/acsmetrics',
          name: 'Screening Metrics',
          component: acsScreeningMetricsReport
        },
        {
          path: '/consolidated_role',
          name: 'Tech Stack Interviewed',
          component: acsConsolidatedRoleReport
        },
        {
          path: '/consolidated_ta',
          name: 'Consolidated-TA Members',
          component: acsConsolidatedTaReport
        },
        {
          path: '/candidate_interview_details',
          name: 'Candidate-Interview Details',
          component: CandidateInterviewDetails
        },
        {
          path: '/payment_summary',
          name: 'Payment Summary',
          component: acsPaymentSummaryReport
        },
        {
          path: '/interview_payment',
          name: 'Panel Member Details',
          component: acsInterviewConductedReport
        }
      ]
    },
    {
      path: '/getauth/:id',
      name: 'getauth',
      component: getauth
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/Termsandcondition',
      name: 'Termsandcondition',
      component: Empty,
      meta: {
        title: 'Terms and condition'
      }
    },
    {
      path: '/result_pdf',
      name: 'ResultPdf',
      component: resultpdf,
      meta: {
        title: 'Terms and condition'
      }
    },
    {
      path: '/feedback_common_pdf',
      name: 'FeedbackCommonPdf',
      component: feedbackCommonPdf,
      meta: {
        title: 'Terms and condition'
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
      meta: {
        title: 'Faq'
      }
    },
    {
      path: '/Registration',
      name: 'Registration',
      component: Registration,
      meta: {
        title: 'Registration'
      }
    },
    {
      path: '/organization_profile_update',
      name: 'organization_profile_update',
      component: OrganizationProfile,
      meta: {
        title: 'organization_profile_update'
      }
    },
    {
      path: '/set/password/:email/:key',
      name: 'setPassword',
      component: SetPassword,
      meta: {
        title: 'setPassword'
      }
    },
    {
      path: '/set/password/mobile/:email/:key',
      name: 'setPasswordMobile',
      component: setpasswordmobile,
      props: true,
      meta: {
        title: 'setPassword'
      }
    },
    {
      path: '/registeration/success',
      name: 'registerationSuccess',
      component: Login,
      meta: {
        title: 'success'
      }
    },
    {
      path: '/registeration/complete',
      name: 'registeration-complete',
      component: Registrationcomplete,
      meta: {
        title: 'complete'
      }
    },
    {
      path: '/forget/password/success',
      name: 'forget-password-success',
      component: ForgetPasswordcomplete,
      meta: {
        title: 'complete'
      }
    },
    {
      path: '/forget/password',
      name: 'forgetPassword',
      component: ForgetPassword,
      meta: {
        title: 'forgetPassword'
      }
    },
    {
      path: '/meeting/:id/:type',
      name: 'AgoraHome',
      component: agoraHome
    },
    {
      path: '/agora/meeting',
      name: 'AgoraMeeting',
      component: agoraMeeting
    },
    {
      path: '/meeting_start/:id/:type/:org',
      name: 'MeetingStart',
      component: meetingstart
    },
    {
      path: '/meeting_end/:id/:type/:org',
      name: 'MeetingEnd',
      component: meetingend
    },
    {
      path: '/feedback_completed',
      name: 'feedbackCompleted',
      component: feedbackEnd
    },
    {
      path: '/meeting_confirmation/:scheduleId/:type',
      name: 'meetingConfirmation',
      component: meetingConfirmation
    },
    {
      path: '/LoginPage',
      name: 'LoginPage',
      component: LoginPage,
      meta: {
        title: 'LoginPage'
      }
    },
    {
      path: '/RegistrationPage',
      name: 'RegistrationPage',
      component: RegistrationPage,
      meta: {
        title: 'RegistrationPage'
      }
    },
    {
      path: '/forgotPasswordPage',
      name: 'forgotPasswordPage',
      component: forgotPasswordPage,
      meta: {
        title: 'forgotPasswordPage'
      }
    },
    {
      path: '/Interviewer_BasicProfile',
      name: 'Interviewer_BasicProfile',
      component: InterviewerBasicProfile,
      meta: {
        title: 'Interviewer_BasicProfile'
      }
    },
    {
      path: '/InterviewerExperience',
      name: 'InterviewerExperience',
      component: InterviewerExperience,
      meta: {
        title: 'InterviewerExperience'
      }
    },
    {
      path: '/InterviewerSkills',
      name: 'InterviewerSkills',
      component: InterviewerSkills,
      meta: {
        title: 'InterviewerSkills'
      }
    },
    {
      path: '/UploadPage',
      name: 'UploadPage',
      component: UploadPage,
      meta: {
        title: 'UploadPage'
      }
    },
    {
      path: '/',
      name: 'package',
      component: packagelayout,
      children: [
        {
          path: '/package/:id',
          name: 'Selectpackage',
          component: Selectpackage
        },
        {
          path: '/packageMessage/:id',
          name: 'PackageMessage',
          component: packageMessage
        },
        {
          path: '/packageMessage1/:id',
          name: 'PackageMessage1',
          component: packageMessage1
        },
        {
          path: '/addfeedback/:id',
          name: 'Addfeedback',
          component: addfeedback
        },
        {
          path: '/addfeedbackcommon/:id',
          name: 'AddfeedbackCommon',
          component: addfeedbackCommon
        },
        {
          path: '/viewfeedbackcommon/:id',
          name: 'ViewfeedbackCommon',
          component: viewfeedbackCommon
        },
        {
          path: '/viewfeedback/:id',
          name: 'Viewfeedback',
          component: viewfeedback
        },
        {
          path: '/viewfeedbackword/:id',
          name: 'Viewfeedbackword',
          component: viewfeedbackfWord
        },
        {
          path: '/viewinterviewvideo/:id',
          name: 'ViewInterviewVideo',
          component: viewInterviewVideo
        },
        {
          path: '/codeeditor/:id',
          name: 'codeeditor',
          component: codeEditor
        },
        {
          path: '/viewcode/:id',
          name: 'viewCode',
          component: viewCode
        },
        {
          path: '/addfeedbackcommon_v3/:id',
          name: 'AddfeedbackCommonV3',
          component: addfeedbackCommonV3
        },
        {
          path: '/viewfeedbackcommon_v3/:id/:view',
          name: 'ViewfeedbackCommonV3',
          component: viewfeedbackCommonV3
        },
        {
          path: '/codeeditor_v3/:id',
          name: 'codeeditorV3',
          component: codeEditorV3
        },
        {
          path: '/viewcode_v3/:id',
          name: 'viewCodeV3',
          component: viewCodeV3
        }
      ]
    },
    {
      path: '/videocall',
      name: 'video-call',
      component: videoCall
    },
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/myVideoCall',
      name: 'myVideoCall',
      component: myVideoCall
    },
    {
      path: '/auth/:provider/callback',
      component: {
        template: '<div class="auth-component"></div>'
      }
    },
    {
      path: '/agoraMod/meeting',
      name: 'AgoraModMeeting',
      component: agoraModMeeting
    },
    {
      path: '/meeting_accept/:id/:type/:org',
      name: 'AcceptPending',
      component: acceptPending
    },
    {
      path: '/',
      redirect: '/Login_v3',
      name: 'HomeNew',
      component: layoutNew,
      children: [
        {
          path: 'dashboardOrg',
          name: 'DashboardNew',
          component: DashboardNew,
          meta: {
            title: 'screenit - dashboard'
          }
        },
        {
          path: '/candidate_profiles/:id/:type',
          name: 'CandidateDetails',
          component: CandidateDetails
        },
        {
          path: '/select_interviewer/:id',
          name: 'SelectInterviewer',
          component: selectInterviewer
        },
        {
          path: 'reportnew',
          name: 'ReportNew',
          component: Report
        },
        {
          path: 'SheduleReportNew',
          name: 'SheduleReportNew',
          component: ShedulelistReport,
          meta: {
            title: 'screenit - dashboard'
          }
        },
        {
          path: '/profile',
          name: 'ProfileNew',
          component: profile
        },
        {
          path: '/settings',
          name: 'SettingsNew',
          component: settings
        }
      ]
    },
    {
      path: '/setAvailability/:sid/:pid',
      name: 'SetAvailability',
      component: SetAvailability
    },
    {
      path: '/viewfeedback_org/:id',
      name: 'newFeedback',
      component: newFeedback
    },
    {
      path: '/confirmation_new/:sid/:uid',
      name: 'ConfirmationNew',
      component: ConfirmationNew
    },
    {
      path: '/schedule_confirmation/:sid/:uid',
      name: 'ScheduleConfirmation',
      component: ScheduleConfirmation
    },
    {
      path: '/request_shortlist/:sid',
      name: 'RequestShortlistV3',
      component: RequestShortlistV3
    },
    {
      path: '/viewinterviewvideo_v3/:id',
      name: 'ViewInterviewVideoV3',
      component: viewInterviewVideoV3
    },
    {
      path: '/set_availability_v3/:sid/:type',
      name: 'SetAvailabilityV3',
      component: SetAvailabilityV3
    },
    {
      path: '/meeting_v3/:id/:type',
      name: 'AgoraHomeV3',
      component: agoraHomeV3
    },
    {
      path: '/agoraMod_v3/meeting',
      name: 'AgoraModMeetingV3',
      component: agoraModMeetingV3
    },
    {
      path: '/meeting_start_v3/:id/:type/:org',
      name: 'MeetingStartV3',
      component: meetingstartV3
    },
    {
      path: '/meeting_end_v3/:id/:type/:org',
      name: 'MeetingEndV3',
      component: meetingendV3
    },
    {
      path: '/meeting_accept_v3/:id/:type/:org',
      name: 'AcceptPendingV3',
      component: acceptPendingV3
    },
    {
      path: '/Registration_v3',
      name: 'RegistrationV3',
      component: RegistrationV3,
      meta: {
        title: 'Registration'
      }
    },
    {
      path: '/registeration/success',
      name: 'registerationSuccessV3',
      component: LoginV3,
      meta: {
        title: 'success'
      }
    },
    {
      path: '/registeration/complete',
      name: 'registeration-completeV3',
      component: RegistrationcompleteV3,
      meta: {
        title: 'complete'
      }
    },
    {
      path: '/organization_profile_update_v3',
      name: 'organization_profile_update_v3',
      component: OrganizationProfileV3,
      meta: {
        title: 'organization_profile_update'
      }
    },
    {
      path: '/set_v3/password/:email/:key/:type',
      name: 'setPasswordV3',
      component: SetPasswordV3,
      meta: {
        title: 'setPassword'
      }
    },
    {
      path: '/forget_v3/password',
      name: 'forgetPasswordV3',
      component: ForgetPasswordV3,
      meta: {
        title: 'forgetPassword'
      }
    },
    {
      path: '/Login_v3',
      name: 'LoginV3',
      component: LoginV3,
      meta: {
        title: 'Login'
      }
    },
    {
      path: '/iaas_redirection/:email',
      name: 'IaaSRedirectionV3',
      component: IaaSRedirectionV3
    },
    {
      path: '/caas_redirection/:email',
      name: 'CaaSRedirectionV3',
      component: CaaSRedirectionV3
    },
    {
      path: '/admin_dashboard',
      name: 'AdminDashboard',
      component: AdminDashboard
    },
    {
      path: '/',
      redirect: '/Login_v3',
      name: 'HomeV3',
      component: layoutV3,
      children: [
        {
          path: 'dashboard_v3',
          name: 'DashboardV3',
          component: DashboardV3,
          meta: {
            title: 'screenit - dashboard'
          }
        },
        {
          path: '/candidate_profiles_v3/:post_id/:post_type/:selectedMetrics',
          name: 'CandidateDetailsV3',
          component: CandidateDetailsV3
        },
        {
          path: '/select_interviewer_v3/:id/:type/:post_type',
          name: 'SelectInterviewerV3',
          component: selectInterviewerV3
        },
        {
          path: '/profile_v3',
          name: 'ProfileV3',
          component: ProfileV3
        },
        {
          path: 'report_v3',
          name: 'ReportV3',
          component: ReportV3
        },
        {
          path: 'adminReport_v3',
          name: 'AdminReportv3',
          component: AdminReportV3
        },
        {
          path: 'orgDetails_v3',
          name: 'OrgDetailsv3',
          component: OrgDetailsV3
        },
        {
          path: 'SheduleReport_v3',
          name: 'SheduleReportv3',
          component: ShedulelistReportV3
        },
        {
          path: '/settings_v3',
          name: 'SettingsV3',
          component: settingsV3
        },
        {
          path: '/admin_settings_v3',
          name: 'AdminSettingsV3',
          component: AdminSettingsV3
        }
      ]
    }
  ]
})
